import React from "react";
import { useUser } from "../context/UserContext";
import { ROLE_LABELS } from "../utils/roleSwitch";
import { FaExchangeAlt, FaBuilding, FaUserTie, FaHome, FaUserShield, FaUsers } from "react-icons/fa";

const ICONS = { 0: FaHome, 1: FaBuilding, 2: FaUserShield, 3: FaUsers, 4: FaUserTie };

/**
 * Selector de plataforma para usuarios multi-rol (mismo email en varios docs de
 * `users`). Muestra accesos a las OTRAS plataformas disponibles; al elegir una,
 * cambia la sesión sin cerrar sesión y recuerda la elección para el próximo login.
 * No renderiza nada si el usuario tiene un solo rol.
 *
 * variant: "menu" (items del dropdown del header) | "card" (bloque en Mi Perfil).
 */
export default function RoleSwitcher({ variant = "menu" }) {
  const { availableRoles = [], switchRole, userType } = useUser();
  const others = (availableRoles || []).filter((r) => Number(r.typeuser) !== Number(userType));
  if (!switchRole || others.length === 0) return null;

  if (variant === "card") {
    return (
      <div style={styles.cardWrap}>
        <div style={styles.cardTitle}><FaExchangeAlt size={13} /> Cambiar de plataforma</div>
        <div style={{ display: "grid", gap: 8 }}>
          {others.map((r) => {
            const Icon = ICONS[r.typeuser] || FaExchangeAlt;
            return (
              <button key={r.docId} onClick={() => switchRole(r)} style={styles.cardBtn}>
                <Icon size={15} color="#0080ff" />
                <span>Ir a {ROLE_LABELS[r.typeuser] || "plataforma"}</span>
              </button>
            );
          })}
        </div>
      </div>
    );
  }

  // variant "menu"
  return (
    <>
      {others.map((r) => {
        const Icon = ICONS[r.typeuser] || FaExchangeAlt;
        return (
          <div
            key={r.docId}
            onClick={() => switchRole(r)}
            role="menuitem"
            tabIndex={0}
            onKeyDown={(e) => e.key === "Enter" && switchRole(r)}
            style={styles.menuItem}
          >
            <Icon size={12} style={{ marginRight: 6, color: "#0080ff" }} />
            Ir a {ROLE_LABELS[r.typeuser] || "plataforma"}
          </div>
        );
      })}
    </>
  );
}

const styles = {
  menuItem: {
    padding: "10px 16px", fontSize: 14, color: "#374151", cursor: "pointer",
    display: "flex", alignItems: "center", transition: "background 0.15s",
    whiteSpace: "nowrap",
  },
  menuDivider: { height: 1, backgroundColor: "#e5e7eb" },
  cardWrap: {
    marginTop: 16, padding: 16, background: "#f8f9fa",
    borderRadius: 12, border: "1px solid #e5e7eb",
  },
  cardTitle: {
    display: "flex", alignItems: "center", gap: 6, fontSize: 13,
    color: "#6b7280", marginBottom: 10,
  },
  cardBtn: {
    display: "flex", alignItems: "center", gap: 8, padding: "10px 12px",
    background: "#ffffff", border: "1px solid #d0e4ff", borderRadius: 8,
    cursor: "pointer", fontSize: 14, color: "#111827", width: "100%",
    textAlign: "left", fontFamily: "inherit",
  },
};
